import React from 'react';
import css from './Resume.module.scss'
import {Field} from "formik";
import {fromDateToStringDate, fromStringDateToDate, getFormattedDate, testDate} from "../../../../utils";
import {Calendar} from "react-date-range";
import calendar from "../../../../images/calendar.svg";
import arrowDown from "../../../../images/input-arrow.svg";
import Input from 'react-phone-number-input/input'
import InputMask from 'react-input-mask';
import {useTranslation} from "react-i18next";

const ResumeInput = ({
                       caption, value, inputWidth, id, handleChange,
                       isEdit, placeholder, setFieldValue, birth, isArrow, list, readonly, postCaption, type, notLatin, error,
                       setFieldError,...props
                     }) => {
  const {t} = useTranslation()
  return (
    (value || isEdit) && <div className={'w-48 mb-24'}>
      <div className={css.resume__item}>
        <p className={css.resume__label}>
          {caption}
        </p>
        {isEdit ? <>
            {id !== 'birth' ? <div className={'modal__row flex-center'}>
              <div style={{width: inputWidth}} className={`modal__inputWrapper ${!inputWidth && 'w-100'}`}>
                {(id === 'phone' || id === 'crewPhone') ? <Input id={'phone'} value={value} onChange={(e) => setFieldValue(id, e)}
                                                                 className={`modal__input w-100`}/>
                  : <Field placeholder={placeholder} value={value} id={id}
                           onChange={e => {
                             if(e.target.value.length < 45) handleChange(e)
                           }} type={type} readOnly={readonly}
                           className={`modal__input w-100 ${error && 'modal__inputError'}`} {...props}/>}
                {isArrow && <button className="modal__arrowIcon">
                  <img src={arrowDown} alt=""/>
                </button>}
                {list && <div className="modal__list">
                  <div className="modal__listItems">
                    {list}
                  </div>
                </div>}
              </div>
              {postCaption && <p className={`${css.resume__value} ml-16`}>{postCaption}</p>}
            </div> : <div className={`modal__date ${error && 'modal__inputError'}`}>
              <div className="modal__dateItem w-100 m-0">
                <InputMask  mask={'99.99.9999'} maskChar={''} permanents={[2, 5]}  id={'birth'}
                            placeholder={placeholder} className={'modal__dateInput w-100'} type="text" autoComplete={'off'}
                            onChange={(e) => {
                              handleChange(e)
                              if (e.target.value.length === 10 && testDate(e.target.value)) setFieldValue('birth', e.target.value)
                            }}
                       value={value !== '...' ? value : ''}/>
                <div className="modal__calendar">
                  <Calendar onChange={item => {
                    setFieldValue('birth', fromDateToStringDate(getFormattedDate(item)))
                  }} date={(value?.length === 10 && testDate(value)) ? new Date(fromStringDateToDate(value)) : null} maxDate={new Date()}/>
                </div>
                <img src={calendar} alt="" className="modal__dateIcon"/>
              </div>
            </div>}
          </>
          : <p className={css.resume__value}>{value} {postCaption}</p>}
      </div>
      {error && <div className={'modal__inputItem mt-0'}>
        <p className="modal__errorText">{error}</p>
      </div>}
    </div>
  );
};

export default React.memo(ResumeInput);
